'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var About;
(function (About) {
    var MyAbout = /** @class */ (function () {
        function MyAbout() {
            var _this = this;
            // PCより大きいサイズ
            this.OVERPCWIDTH = 1200;
            this.ABOUTHEIGHT = 1080;
            // CELLS
            this.initializeCellsWidth = 1890;
            this.initializeCellsMargin = 940;
            // CELL
            this.initializeCellWidth = 472;
            // LINE
            this.initializeLineWidth = 1358;
            this.initializeLineHeight = 1018;
            this.initializeLineMargin = 1123;
            // 神研
            this.initializeTitleWidth = 415;
            this.initializeTitleHeight = 324;
            this.initializeTitleMargin = 540;
            // とは
            this.initializeSubWidth = 158;
            this.initializeSubHeight = 119;
            this.initializeSubMargin = 35;
            // 紹介文
            this.initializeIntroWidth = 533;
            this.initializeIntroHeight = 246;
            this.initializeIntroMargin = 555;
            // 神戸薬科大学の「研究力」
            this.initializeBasisWidth = 457;
            this.initializeBasisHeight = 202;
            this.initializeBasisMargin = 550;
            // 科研費新規採択率
            this.initializeItem01Width = 322;
            this.initializeItem01Height = 174;
            this.initializeItem01Margin = 548;
            // 科研費配分額
            this.initializeItem02Width = 429;
            this.initializeItem02Height = 174;
            this.initializeItem02Margin = 548;
            // 神戸大学大学院医学研究科
            this.initializeItem03Width = 392;
            this.initializeItem03Height = 179;
            this.initializeItem03Margin = 548;
            var self = this;
            $(window).on('load', function () {
                _this.resizeTopView();
            });
            $(window).on('resize', function () {
                _this.resizeTopView();
            });
        }
        MyAbout.prototype.isPcWidth = function () {
            var isPcWidth = false;
            var browserWidth = $(window).outerWidth();
            if (browserWidth >= this.OVERPCWIDTH) {
                isPcWidth = true;
            }
            return isPcWidth;
        };
        MyAbout.prototype.resizeTopView = function () {
            if (this.isPcWidth()) {
                //const browserHeight: number = $(window).outerHeight();
                var browserHeight = $(window).outerHeight();
                $('.bulletAbout').css('height', browserHeight);
                $('.bulletAboutBlock').css('height', browserHeight);
                var scale = this.calculateScale();
                this.resizeAboutCells(scale);
                this.resizeAboutCell(scale);
                this.resizeAboutLine(scale);
                this.resizeAboutTitle(scale);
                this.resizeAboutSub(scale);
                this.resizeAboutIntro(scale);
                this.resizeAboutBasis(scale);
                this.resizeAboutItem01(scale);
                this.resizeAboutItem02(scale);
                this.resizeAboutItem03(scale);
            }
        };
        MyAbout.prototype.calculateScale = function () {
            var browserHeight = $(window).outerHeight();
            return browserHeight / this.ABOUTHEIGHT;
        };
        MyAbout.prototype.resizeAboutCells = function (scale) {
            var changeWidth = this.initializeCellsWidth * scale;
            var moveLeft = this.initializeCellsMargin * scale;
            $('.bulletResizeAboutCells').css({ 'width': changeWidth, 'margin-left': -moveLeft });
        };
        MyAbout.prototype.resizeAboutCell = function (scale) {
            var changeWidth = this.initializeCellWidth * scale;
            $('.bulletResizeAboutCell').css({ 'width': changeWidth });
        };
        MyAbout.prototype.resizeAboutLine = function (scale) {
            var changeWidth = this.initializeLineWidth * scale;
            var changeHeight = this.initializeLineHeight * scale;
            var moveLeft = this.initializeLineMargin * scale;
            $('.bulletResizeAboutLine').css({ 'width': changeWidth, 'height': changeHeight, 'margin-left': -moveLeft });
        };
        MyAbout.prototype.resizeAboutTitle = function (scale) {
            var changeWidth = this.initializeTitleWidth * scale;
            var changeHeight = this.initializeTitleHeight * scale;
            var moveLeft = this.initializeTitleMargin * scale;
            $('.bulletResizeAboutTitle').css({ 'width': changeWidth, 'height': changeHeight, 'margin-left': -moveLeft });
        };
        MyAbout.prototype.resizeAboutSub = function (scale) {
            var changeWidth = this.initializeSubWidth * scale;
            var changeHeight = this.initializeSubHeight * scale;
            var moveLeft = this.initializeSubMargin * scale;
            $('.bulletResizeAboutSub').css({ 'width': changeWidth, 'height': changeHeight, 'margin-left': -moveLeft });
        };
        MyAbout.prototype.resizeAboutIntro = function (scale) {
            var changeWidth = this.initializeIntroWidth * scale;
            var changeHeight = this.initializeIntroHeight * scale;
            var moveLeft = this.initializeIntroMargin * scale;
            $('.bulletResizeAboutIntro').css({ 'width': changeWidth, 'height': changeHeight, 'margin-left': -moveLeft });
        };
        MyAbout.prototype.resizeAboutBasis = function (scale) {
            var changeWidth = this.initializeBasisWidth * scale;
            var changeHeight = this.initializeBasisHeight * scale;
            var moveLeft = this.initializeBasisMargin * scale;
            $('.bulletResizeAboutBasis').css({ 'width': changeWidth, 'height': changeHeight, 'margin-left': -moveLeft });
        };
        MyAbout.prototype.resizeAboutItem01 = function (scale) {
            var changeWidth = this.initializeItem01Width * scale;
            var changeHeight = this.initializeItem01Height * scale;
            var moveLeft = this.initializeItem01Margin * scale;
            $('.bulletResizeAboutItem01').css({ 'width': changeWidth, 'height': changeHeight, 'margin-left': -moveLeft });
        };
        MyAbout.prototype.resizeAboutItem02 = function (scale) {
            var changeWidth = this.initializeItem02Width * scale;
            var changeHeight = this.initializeItem02Height * scale;
            var moveLeft = this.initializeItem02Margin * scale;
            $('.bulletResizeAboutItem02').css({ 'width': changeWidth, 'height': changeHeight, 'margin-left': -moveLeft });
        };
        MyAbout.prototype.resizeAboutItem03 = function (scale) {
            var changeWidth = this.initializeItem03Width * scale;
            var changeHeight = this.initializeItem03Height * scale;
            var moveLeft = this.initializeItem03Margin * scale;
            $('.bulletResizeAboutItem03').css({ 'width': changeWidth, 'height': changeHeight, 'margin-left': -moveLeft });
        };
        return MyAbout;
    }());
    About.MyAbout = MyAbout;
})(About || (About = {}));
exports.default = About;
